// @ts-nocheck
export const selectSubscriptions = state => state.subscription.subscriptions?.data;
export const selectSubscriptionDetails = state => state.subscription.subscriptionDetails;
export const selectChannels = state => state.subscription.channels?.products;
export const selectProducts = state => state.subscription.products?.products;
export const selectDiscountReasons = state => state.subscription.discountReasons?.reasons;
